import { useCategoriesStore } from '@/store/categoriesStore';
import { useProductsStore } from '@/store/productsStore';
import { usePagesStore } from '@/store/pagesStore';
import { useActiveUrlStore } from '@/store/activeUrlStore';
import useAuth from '@/composables/useAuth/useAuth';
import IExportData from '@/interfaces/IExportData';
import { GoogleAnalytics } from '@/services/analytics/googleAnalytics';

function exportCategoriesAndProductsToJson() {

  GoogleAnalytics.exportButtonClick();

  const categoriesStore = useCategoriesStore();
  const productsStore = useProductsStore();
  const pagesStore = usePagesStore();
  const activeUrlStore = useActiveUrlStore();
  const provider = activeUrlStore.getProvider;
  const auth = useAuth();

  try {

    // Format date as yyyy-MM-dd-hh-mm-ss
    const now = new Date();
    const formattedDate = now.toISOString().replace(/[-T:]/g, '_').split('.')[0];

    // Turn into URL object
    const FQDNurl = new URL(activeUrlStore.activeUrl);

    // Construct file name
    const filename = `${FQDNurl.hostname}-${provider}-${formattedDate}.json`;

    // Prepare JSON data
    const data: IExportData = {
      site: activeUrlStore.activeUrl,
      timestamp: new Date().toISOString(),
      exportedBy: auth.getUser?.username ?? 'unknown',
      provider: activeUrlStore.getProvider,
      categories: categoriesStore.categories,
      products: productsStore.products,
      pages: pagesStore.pages,
    };

    const jsonData = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonData], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    // Create and trigger download
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    GoogleAnalytics.exportJsonSuccessful();

  } catch (error) {
    GoogleAnalytics.exportJsonFailed();
  }
}

export default exportCategoriesAndProductsToJson;
